import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UsuariosService } from '../../../services/usuarios.service';
import { UsuarioRolesService } from '../../../services/usuario-roles.service';

@Component({
  selector: 'app-cons-func-roles-usu',
  templateUrl: './cons-func-roles-usu.component.html',
  styleUrls: ['./cons-func-roles-usu.component.css']
})
export class ConsFuncRolesUsuComponent implements OnInit {

  titulo = 'Consulta de funcionalidades y roles que posee un usuario';
  subtitulo1 = 'Aplicativos en los que tiene permisos y roles';
  subtitulo2 = 'Roles autorizados para esta funcionalidad';
  usuarios: any
  list_rol_s: string[] = [];
  indice: string | undefined;
  //id: number | undefined;
  idUsuario:string=''
  usuario:any = {
    idUsuario:'',
    nombreUsuario:'',
    email:'',
    perfil:'',
    area:''
  }
  showlist :boolean=false;

  listUsuariosdepurada:any[]=[];
  respuesta:any
  listAplicativos:any
  listRoles:any
  listUsuarios:any
  constructor(private usuariosService: UsuariosService,
              private usuarioRolesService: UsuarioRolesService,
              private route: ActivatedRoute,
              private router: Router) {
    if (this.route.snapshot.paramMap.get('id') != null) {
      this.idUsuario = this.route.snapshot.paramMap.get('id')!;

    }
    else {
      this.showlist=true;
      this.usuariosService.traerUsuario("")
        .subscribe(resp => {
          this.respuesta = resp;
          this.listUsuarios = this.respuesta.data
          this.quitarDuplicadosUsuarios()
        });
    }
  }

  ngOnInit(): void {
    this.traerUsuarioById()
  }

  traerUsuarioById():void{
    console.log(this.idUsuario);
    if(this.idUsuario!="")
    {
      this.usuariosService.traerUsuarioById(this.idUsuario)
        .subscribe(resp => {
          this.respuesta = resp;
          this.usuario = {
            idUsuario : this.respuesta.data[0].idUsuario,
            nombreUsuario:this.respuesta.data[0].nombreUsuario,
            email:this.respuesta.data[0].email,
            perfil:this.respuesta.data[0].perfil,
            area:this.respuesta.data[0].area
          }
          this.cargarAplicativos(this.respuesta.data)
        })
    }

  }

  cargarAplicativos(data:any){
    let aplication:any
    let respuesta: any = []
    this.listAplicativos = []

    data.forEach((item: {nombreAplicativo: string; idAplicativo: string; })=>{
      aplication = {
        idAplicativo:'',
        nombreAplicativo:''
      }
      aplication.idAplicativo = item.idAplicativo
      aplication.nombreAplicativo = item.nombreAplicativo
      respuesta.push(aplication)
      this.listAplicativos = this.quitarDuplicados(respuesta)
    })
  }
  quitarDuplicadosUsuarios(){
    let usuario:any
    let cadena:any[] =[];

    this.listUsuarios.forEach((data: {
      idUsuario: string;
      nombreUsuario:string;
      email:string;
      perfil:string;
      area:string
    }) => {
      usuario={
        idUsuario:'',
        nombreUsuario:'',
        email:'',
        perfil:'',
        area:''
      }
      usuario.idUsuario = data.idUsuario
      usuario.nombreUsuario = data.nombreUsuario
      usuario.email=data.email
      usuario.perfil = data.perfil
      usuario.area = data.area
      if (!cadena.includes(data.idUsuario)) {
        this.listUsuariosdepurada.push(usuario);
        cadena.push(data.idUsuario);
      }
    });
  }

  quitarDuplicados(data:any){
    const unique: any[] = [];
    data.forEach((item: any) => {
      if (!unique.includes(item)) {
        unique.push(item);
      }
    })
    return unique
  }
  cargarUsuarios(): void{
    this.usuariosService.traerUsuarios()
    .subscribe(resp => {
      this.usuarios = resp;
    });
  }

  regresar(): void{
    this.router.navigateByUrl('usuarios');
  }





  cargarRoles(id: string): void{
    let respuesta:any = []
    let rol: string
    let roles:string[]=[]
    this.listRoles=[]
    this.indice = id
    respuesta = this.respuesta.data
    respuesta.forEach((item:any)=>{
      rol = ''
      if(item.idAplicativo == id){
        rol = item.nombreRol
        roles.push(rol)
      }
    })
    this.listRoles = this.quitarDuplicados(roles)
  }


}
